export default "__VITE_ASSET__1iUcUdNC__"